import { consoleErrorWithSentry } from "../../utils";

import cdAppSettings from "./cdAppSetting";

export const deleteCloudDiagram = async ({ api, schemeId, customer, onSuccess = () => {}, onError = () => {} }) => {
  if (!schemeId || !customer?.id) {
    consoleErrorWithSentry("Wrong scheme id or customer id");
    onError();
    return;
  }

  try {
    const { data } = await api.request({
      method: "post",
      baseURL: cdAppSettings.baseUrl,
      url: "/cloud-diagrams/api/scheme/batch",
      params: {
        customer: customer.id,
      },
      data: {
        delete: {
          scheme: [schemeId],
        },
      },
    });

    if (data?.delete?.scheme) {
      onSuccess(data);
    } else {
      onError("Something went wrong");
    }
  } catch (err) {
    consoleErrorWithSentry(err);
    onError(err);
  }
};
